// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Input_inputWrapper__2QSwg","input":"Input_input__0ixYc"};